import { UserSignature } from "../../user";
import {
    CreateUserSignatureRequestBody,
    UpdateUserSignatureRequestBody,
    UserSignatureDTO,
} from "../types/apiResponse";

export function toDomainUserSignature(dto: UserSignatureDTO): UserSignature {
    return {
        id: dto.id,
        userId: dto.userId,
        signatureTitle: dto.signatureTitle,
        name: dto.name,
        jobTitle: dto.jobTitle,
        email: dto.email,
        companyName: dto.companyName,
        phone: dto.phone,
        website: dto.website,
        other: dto.other,
        avatar: dto.avatar,
        isFavorite: dto.isFavorite,
    };
}

export function toDtoUserSignatureInput(
    sig: Omit<UserSignature, "id" | "userId" | "isFavorite">,
): CreateUserSignatureRequestBody {
    return {
        signatureTitle: sig.signatureTitle,
        name: sig.name,
        jobTitle: sig.jobTitle,
        email: sig.email,
        companyName: sig.companyName,
        phone: sig.phone,
        website: sig.website,
        other: sig.other,
        avatar: sig.avatar,
    };
}

export function toDtoUserSignatureUpdate(
    sig: UserSignature,
): UpdateUserSignatureRequestBody {
    return {
        id: sig.id,
        userId: sig.userId,
        signatureTitle: sig.signatureTitle,
        name: sig.name,
        jobTitle: sig.jobTitle,
        email: sig.email,
        companyName: sig.companyName,
        phone: sig.phone,
        website: sig.website,
        other: sig.other,
        avatar: sig.avatar,
        isFavorite: sig.isFavorite,
    };
}
